const People2 = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-people"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-people"
      viewBox="0 0 16 15"
      width={_width}
      {...props}
    >
      <path
        d="M11.75 4.475C11.7125 4.46875 11.6687 4.46875 11.6312 4.475C10.7687 4.44375 10.0812 3.7375 10.0812 2.8625C10.0812 1.96875 10.8 1.25 11.6937 1.25C12.5875 1.25 13.3062 1.975 13.3062 2.8625C13.3 3.7375 12.6125 4.44375 11.75 4.475Z"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1062 9.02498C11.9625 9.16873 12.9062 9.01873 13.5687 8.57498C14.45 7.98748 14.45 7.02498 13.5687 6.43748C12.9 5.99373 11.9437 5.84373 11.0875 5.99373"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.2313 4.475C4.2688 4.46875 4.31255 4.46875 4.35005 4.475C5.21255 4.44375 5.90005 3.7375 5.90005 2.8625C5.90005 1.96875 5.1813 1.25 4.28755 1.25C3.3938 1.25 2.67505 1.975 2.67505 2.8625C2.6813 3.7375 3.3688 4.44375 4.2313 4.475Z"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.87502 9.02498C4.01877 9.16873 3.07502 9.01873 2.41252 8.57498C1.53127 7.98748 1.53127 7.02498 2.41252 6.43748C3.08127 5.99373 4.03752 5.84373 4.89377 5.99373"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99999 9.14376C7.96249 9.13751 7.91874 9.13751 7.88124 9.14376C7.01874 9.11251 6.33124 8.40626 6.33124 7.53126C6.33124 6.63751 7.04999 5.91876 7.94374 5.91876C8.83749 5.91876 9.55624 6.64376 9.55624 7.53126C9.54999 8.40626 8.86249 9.11876 7.99999 9.14376Z"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.18126 11.1125C5.30001 11.7 5.30001 12.6625 6.18126 13.25C7.18126 13.9188 8.81876 13.9188 9.81876 13.25C10.7 12.6625 10.7 11.7 9.81876 11.1125C8.82501 10.45 7.18126 10.45 6.18126 11.1125Z"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default People2;
